import Home from "./pages/Home";
import Login from "./pages/Login";
import { useState, useEffect } from "react";

// import { redirectToAuthCodeFlow, getAccessToken} from './spotifyAPI';

// const clientId = "a7ec7b2d86c448a480bf3b1066b5e2f3";
// const params = new URLSearchParams(window.location.search);
// const code = params.get("code");

// async function login(){
//   if(!code){
//     redirectToAuthCodeFlow(clientId);
//   }
// }

function App() {
  const [loggedIn, setLoggedIn] = useState(false);

  if(!loggedIn) {
    return (
      <Login setLoggedIn={setLoggedIn}/>
    );
  }

  return <Home />

  // if(!code && !localStorage.getItem("accessToken")){
  //   return (
  //     <Login loginFunction={login}/>
  //   );
  // }
  // else {

  //   const fetchToken = async () => {
  //     setLoading(true);
  //     try{
  //       const accessTokenReceived = await getAccessToken(clientId, code);
  //       localStorage.setItem("accessToken", accessTokenReceived);
  //     } 
  //     catch (error) {
  //       console.error("Error fetching token:", error);
  //     }
  //     finally {
  //       // console.log(accessToken);
  //       setLoading(false);
  //     }
  //   }

  //   useEffect(() => {
  //     const storedToken = localStorage.getItem("accessToken");

  //     // If token exists in localStorage, no need to call fetchToken
  //     if (storedToken) {
  //       return;
  //     }

  //     if (code) {
  //       fetchToken();
  //     }
  //   }, [code]); // Fetch token whenever `code` changes

  //   if (loading) {
  //     return <div>Loading...</div>; // Show loading while waiting for API call
  //   }

  //   return (
  //     <Home/>
  //   );
  // }
}

export default App;
